import { MINDESTBELEGUNG_BY_STANDORT_ID_AND_DATUM } from '@/domain/controlling/hooks/graphql/queries';
import {
  Controlling_MindestbelegungByStandortIdAndDatumQuery,
  Controlling_MindestbelegungByStandortIdAndDatumQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client';
import * as Sentry from '@sentry/browser';

export function useMindestbelegung(
  datum: string,
  standortId: string,
): number | undefined {
  const { data, error } = useSuspenseQuery<
    Controlling_MindestbelegungByStandortIdAndDatumQuery,
    Controlling_MindestbelegungByStandortIdAndDatumQueryVariables
  >(MINDESTBELEGUNG_BY_STANDORT_ID_AND_DATUM, {
    variables: { datum, standortId },
    fetchPolicy: 'network-only',
  });

  if (error) {
    Sentry.captureException(error);
    return undefined;
  }

  return data.controlling_mindestbelegungByStandortIdAndDatum.dauer;
}
